/**
 * Sticky Add to Cart for Mobile
 * Shows a sticky "Add to Cart" button at the bottom when user scrolls past the original button
 */

class StickyAddToCart {
  constructor() {
    this.init();
  }

  init() {
    // Only run on mobile devices
    if (window.innerWidth > 749) return;

    const stickyWrapper = document.querySelector('.product-form__sticky-wrapper');
    const originalButton = document.querySelector('#ProductSubmitButton-' + this.getSectionId());

    if (!stickyWrapper || !originalButton) return;

    // Button is always visible on mobile - no intersection observer needed
    // Just sync state between sticky and original button
    this.syncButtonState(stickyWrapper, originalButton);
  }

  getSectionId() {
    const productInfo = document.querySelector('[data-section]');
    return productInfo ? productInfo.dataset.section : '';
  }

  syncButtonState(stickyWrapper, originalButton) {
    // Watch for changes to the original button's disabled state
    const observer = new MutationObserver(() => {
      const stickyButton = stickyWrapper.querySelector('button');
      const isDisabled = originalButton.hasAttribute('disabled');

      if (isDisabled) {
        stickyButton.setAttribute('disabled', '');
      } else {
        stickyButton.removeAttribute('disabled');
      }

      // Sync button text
      const originalText = originalButton.querySelector('span').textContent;
      const stickyText = stickyButton.querySelector('span');
      if (stickyText && originalText) {
        stickyText.textContent = originalText;
      }
    });

    observer.observe(originalButton, {
      attributes: true,
      attributeFilter: ['disabled'],
      subtree: true,
      characterData: true,
      childList: true
    });
  }
}

// Initialize on DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => new StickyAddToCart());
} else {
  new StickyAddToCart();
}
